// extracted by mini-css-extract-plugin
export default {"tag":"InputHashTagRow_tag__U6J-1"};